/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';
import { TextField } from '../../components/TextField';
import { QuestionNumberBadge } from '../../../QuestionNumberBadge/QuestionNumberBadge';

const Label = styled('label')`
  display: inline-flex;
  flex: 1 0 auto;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 105px);
  position: relative;
  margin: 7px 0 12px 0;
  color: ${tokens.color.text_light};

  &::before {
    content: '';
    position: absolute;
    left: -19px;
    top: 13px;
    height: 1px;
    width: 11px;
    background: ${tokens.color.neutral_200};
  }
`;
const Counter = styled(QuestionNumberBadge)`
  flex: 0 0 auto;
  margin-left: 6px;
`;
const FieldContainer = styled('div')`
  display: inline-block;
  flex: 1 1 auto;
  margin-left: 8px;
  width: calc(100% - 125px);
`;
const StyledField = styled(TextField)`
  height: 30px;
  font-size: 11px;
  font-weight: normal;
`;

export const LabeledField = ({
  className,
  counter,
  label,
  hasError,
  name,
  onChange,
  placeholder,
  value,
  rtl,
}) => (
  <Label className={className}>
    {label}
    {counter && <Counter size="sm">{counter}</Counter>}
    <FieldContainer>
      <StyledField
        aria-label={placeholder}
        hasError={hasError}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        rtl={rtl}
      />
    </FieldContainer>
  </Label>
);
